import RequestApi from "./RequestApi";
import {
    authApi,
    authorizationApi, 
    catNipApi,
    userApi,
    howToVideosApi,
} from "./router";

export const api = new RequestApi()

const initRoute = [
    ...authApi,
    ...userApi,
    ...authorizationApi,
    ...catNipApi,
    ...howToVideosApi,
]

initRoute.map((route)=>{
    api.addRoute(route)
})